export const COLLECTIONS = {
  USERS: 'users',
  ANALYSES: 'analyses',
  SUBSCRIPTIONS: 'subscriptions'
} as const;

export const INDEXES = {
  ANALYSES: {
    BY_USER_AND_DATE: {
      fields: ['userId', 'createdAt'],
      order: 'DESCENDING'
    }
  }
} as const;